import { render, staticRenderFns } from "./kpInfor.vue?vue&type=template&id=4327fa54&scoped=true&"
import script from "./kpInfor.vue?vue&type=script&lang=js&"
export * from "./kpInfor.vue?vue&type=script&lang=js&"
import style0 from "./kpInfor.vue?vue&type=style&index=0&id=4327fa54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327fa54",
  null
  
)

export default component.exports